<p-tabMenu [model]="tabItems" scrollable="false" [(activeItem)]="activeTab" *ngIf="context.event.registrationRequired && context.event.feedbackAllowed">
    <ng-template #item let-item><a pRipple class="p-menuitem-link" [class.font-semibold]="item == activeTab">{{ item.label }}</a></ng-template>
</p-tabMenu>
<div class="flex-1 relative">
    <div class="absolute w-full h-full overflow-y-auto overflow-hidden">
        <lib-event-sign-ups-overview (closeEventSignUpsOverview)="close.emit($event)"
            *ngIf="activeTab.id === 'registrations'" [context]="context"></lib-event-sign-ups-overview>
        <app-event-feedback-overview *ngIf="activeTab.id === 'feedback'"
            [context]="context"></app-event-feedback-overview>
    </div>
</div>
